// sendEvent({
//   eventType: 'landing_click_play',
//   eventSource: store.eventSource,
//   eventInfo: '',
// });
import { sendEvent } from '../../../shared/helpers/requests';

const SOURCE = 'mini_land_vebinar';
const SOURCE_TEST = 'mini_land_vebinar_test';


export const EVENT_TYPES = {
  VEB_REGISTRATION_ATTAND: 'pryamyye_efiry_reg',
  FILL_EMAIL: 'email_symbols',
  SIGN_FREE_CLICK: 'click_sign_up',
  GO_TO_CAPCHA: 'seen_capcha',
  CLOSE_CAPCHA_MODAL: 'click_back_capcha',
  CAPCHA_WRONG: 'capcha_wrong',
  GO_TO_CONGRAT: 'congrat',
  GO_TO_LEND_ALREADY_REGISTERED: 'pryamyye_efiry_reg_end',
};

export const EVENT_TYPES_TEST = {
  VEB_ATTAND: 'pryamyye_efiry',
  CLICK_BUY: 'click_buy',
  SORRY_PAGE: 'sorry_page',
  CLICK_MAIN: 'click_main',
  GO_TO_LEND_ALREADY_REGISTERED: 'pryamyye_efiry_end',
}

export const sendOneManyMiniEvent = (type: keyof typeof EVENT_TYPES, info?: any) => {
  sendEvent({
    eventType: EVENT_TYPES[type],
    eventSource: SOURCE,
    eventInfo: info || '',
  });
};

export const sendOneManyMiniSubEvent = (type: keyof typeof EVENT_TYPES_TEST, info?: any) => {
  sendEvent({
    eventType: EVENT_TYPES_TEST[type],
    eventSource: SOURCE_TEST,
    eventInfo: info || '',
  });
};
